import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import './CustomNoRowsOverlay.scss';

interface Props {
  message?: string;
  className?: string;
}

const CustomNoRowsOverlay: React.FC<Props> = ({message, className}) => (
  <Box className={`custom-no-row-overlay-container ${className}`}>
    <Typography
      className="typo-text body3_size message-label"
      tabIndex={0}
      data-testid={`custom-no-rows-overlay-typography`}>
      {message ?? t('common.arrDataGrid.noQueryReturnDataMsg')}
    </Typography>
  </Box>
);

export default CustomNoRowsOverlay;
